/** Ten-digit phone for duplicate checks (ignores +91, spaces, and other formatting). */
export function normalizePhoneDigits(phone: string | null | undefined): string {
  const trimmed = phone?.trim() ?? '';
  if (!trimmed) return '';

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    return digits.slice(2);
  }
  if (digits.length > 10) {
    return digits.slice(-10);
  }
  return digits;
}

/** Canonical storage format: +91 XXXXXXXXXX */
export function formatPhoneForStorage(phone: string | null | undefined): string | null {
  if (!phone?.trim()) return null;
  const { isValid, formattedNumber } = validatePhoneNumber(phone);
  return isValid ? formattedNumber : phone.trim();
}

export const validatePhoneNumber = (phone: string): { isValid: boolean; formattedNumber: string } => {
  // Remove all non-digit characters except the first +91
  const digits = normalizePhoneDigits(phone);
  
  // Check if number has exactly 10 digits
  const isValid = /^\d{10}$/.test(digits);
  
  // Always format with +91 prefix
  const formattedNumber = `+91 ${digits.slice(0, 10)}`;
    
  return { isValid, formattedNumber };
};